import { useRef, useEffect, useState } from "react";
import "./profileDetail.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { Spin } from "antd";

const ProfilePage = ({ person }) => {
  const location = useLocation();
  const scrollButtonRef = useRef(null);
  const [showScrollButtonStart, setShowScrollButtonStart] = useState(true);
  const [activeTab, setActiveTab] = useState("aboutMe");
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [socialMedia, setSocialMedia] = useState({});

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  const fetchData = async(setLoading) => {
    try {
      const response = await axios.get("http://devapps.datadrivensystems.co.uk/alcott-profile-api/api/teams/detail?team_id="+person.team_id);
      setDatas(response.data);
      const { linkedin, facebook, twitter, instagram } = response.data;
      setSocialMedia({ linkedin, facebook, twitter, instagram });
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData(setLoading);
  }, [])

  

  const scrollToTop = () => {
    const konten1 = document.getElementById("wrapper-profile");
    if (konten1) {
      konten1.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToBottom = () => {
    const konten1 = document.getElementById("wrapper-profile");
    if (konten1) {
      konten1.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;
      const scrollHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollPercentage = (scrollPosition / scrollHeight) * 100;

      if (scrollPercentage >= 90) {
        setShowScrollButtonStart(false);
      } else {
        setShowScrollButtonStart(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scrollButtonRef.current) {
      scrollButtonRef.current.addEventListener("click", scrollToTop);
      scrollButtonRef.current.addEventListener("click", scrollToBottom);
    }

    return () => {
      if (scrollButtonRef.current) {
        scrollButtonRef.current.removeEventListener("click", scrollToTop);
        scrollButtonRef.current.removeEventListener("click", scrollToBottom);
      }
    };
  }, []);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  // Dummy data for profile
  const profileData = {
    name: "Septy",
    role: "UI UX Designer",
    backgroundPerson: "I'm a passionate UI/UX designer with a keen eye for aesthetics and a user-centric approach. I thrive in collaborative environments and find joy in crafting intuitive and delightful user experiences. When I'm not designing, you might find me sketching, exploring new design trends, or getting lost in a good book.",
    avatarUrl:
      "https://res.cloudinary.com/alcottimg/image/upload/v1710750783/Website%20Alcott%20Smg/Team/Septy1_u8ujhl.png",
    socialMedia: [
      { name: "+ LinkedIn", url: "https://www.linkedin.com/in/septy" },
      { name: "+ Facebook", url: "https://www.facebook.com/septy" },
      { name: "+ Twitter", url: "https://twitter.com/septy" },
      { name: "+ Instagram", url: "https://www.instagram.com/septy" },
    ],
    skills: [
      { id: 1, name: "Graphic Design" },
      { id: 2, name: "Web Design" },
      { id: 3, name: "Mobile Design" },
      { id: 4, name: "QA Testing" },
    ],
    tools: [
      { id: 1, name: "Adobe XD" },
      { id: 2, name: "Adobe Photoshop" },
      { id: 3, name: "Adobe Illustrator" },
      { id: 4, name: "Figma" },
    ],
  };

  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);

  if (loading) {
    return (
      <div id="globalLoader">
          <div className="loading-screen">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
          </div>
      </div>
    );
  }

  return (
    <>
      <div className="relative" id="wrapper-profile">
        <div className="sticky top-0 z-10 min-h-screen">
          <div className="py-8 text-center flex flex-col items-center justify-center  min-h-screen bg-[#308595] relative bg-custom">
            <div
              className="flex items-center profile-section1 "
              // data-aos="fade-up"
              // data-aos-duration="1000"
              // data-aos-easing="ease-in-out-sine"
            >
              <div className="text-left lg:w-[485px]">
                <div className="hi-there">
                  <p>Hi There</p>
                </div>
                <h1 className="member-name">{`I am ${datas.name}`}</h1>
                <h1 className="member-name">{datas.position}</h1>
                <div className="flex items-center gap-8 mt-5 sosmed-member ">
                {Object.entries(socialMedia).map(([name, url]) => (
                  url && (
                    <a href={url} target="_blank" rel="noopener noreferrer" key={name}>
                      + {name.charAt(0).toUpperCase() + name.slice(1)}
                    </a>
                  )
                ))}
                </div>
              </div>
              <div>
                <img
                  className="w-[300px] h-[300px] xl:w-[320px] xl:h-[320px] avatar-first"
                  src={datas.profile_landing}
                  alt={`Avatar of ${datas.name}`}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-20 ml-auto">
          <div className="dot-big">
            <img
              style={{ width: "350px", height: "350px" }}
              src="https://res.cloudinary.com/alcottimg/image/upload/v1718338219/Website%20Alcott%20Smg/Profile%20Team%20Member%20Assets/Circle_Green_Trans_Big_qgau8d.png"
              alt="Dot Big"
            />
          </div>
          <div className="flex items-center justify-center min-h-screen bg-[#FAFAFA]">
            {/* Scroll Button Start */}
            {showScrollButtonStart ? (
              <div className="icon-scroll-wrapper-start">
                <button
                  id="scrollButtonUp"
                  className="scroll-btn-100"
                  ref={scrollButtonRef}
                  onClick={scrollToBottom}
                >
                  <img
                    src="https://res.cloudinary.com/alcottimg/image/upload/v1718338220/Website%20Alcott%20Smg/Profile%20Team%20Member%20Assets/Arrow_Up_wptg7d.png"
                    width="23px"
                    height="23px"
                    alt="Scroll to Top"
                  />
                </button>
              </div>
            ) : (
              <div className="icon-scroll-wrapper-end">
                <button
                  id="scrollButtonDown"
                  className="scroll-btn-100"
                  ref={scrollButtonRef}
                  onClick={scrollToTop}
                >
                  <img
                    src="https://res.cloudinary.com/alcottimg/image/upload/v1718338220/Website%20Alcott%20Smg/Profile%20Team%20Member%20Assets/Arrow_Up_wptg7d.png"
                    width="23px"
                    height="23px"
                    alt="Scroll to Top"
                    style={{ transform: "rotate(180deg)" }}
                  />
                </button>
              </div>
            )}
            {/* Scroll Button End */}

            <div
              className="flex gap-8 justify-center relative profile-section2"
              style={{ marginTop: "15vh" }}
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out-sine"
            >
              <div className="rounded bg-[#F1F1F1] flex items-center justify-center z-100 pt-2 pb-10 pr-5 relative">
                <img
                  className="lg:w-[300px] lg:h-[300px] xl:w-[320px] xl:h-[320px] "
                  src={datas.profile_image}
                  alt={`Avatar of ${datas.name}`}
                />

                <div className="dot-square z-2">
                  <img
                    style={{ width: "250px", height: "130px" }}
                    src="https://res.cloudinary.com/alcottimg/image/upload/v1718338219/Website%20Alcott%20Smg/Profile%20Team%20Member%20Assets/Dots_Green_tyckjk.png"
                    alt="Dot Square"
                  />
                </div>
              </div>
              <div className="blue-rounded z-1">
                <img
                  style={{ width: "180px", height: "180px" }}
                  src="https://res.cloudinary.com/alcottimg/image/upload/v1718338219/Website%20Alcott%20Smg/Profile%20Team%20Member%20Assets/Circle_Green_Trans_Big_qgau8d.png"
                  alt="Blue Rounded"
                />
              </div>
              <div className="text-left lg:w-[480px]">
                <div className="flex items-center gap-4">
                  {["aboutMe", "skills", "tools"].map((tabName) => (
                    <div
                      key={tabName}
                      className={`tabs-menu ${activeTab === tabName ? "active-tab" : ""
                        }`}
                      onClick={() => handleTabClick(tabName)}
                    >
                      <p className="">{tabName.toUpperCase()}</p>
                    </div>
                  ))}
                </div>

                {/* Tab Content */}
                <div
                  className="tab-content"
                  style={{
                    display: activeTab === "aboutMe" ? "block" : "none",
                  }}
                >
                  <h1 className="my-2">My Background</h1>
                  <p className="text-justify text-[#828282]">
                    {datas.about}
                  </p>
                </div>

                <div
                  className="tab-content"
                  style={{ display: activeTab === "skills" ? "block" : "none" }}
                >
                  <h1> My Skills</h1>
                  <p className="text-justify text-[#828282] mb-3">
                    {datas.skill_desc}
                  </p>

                  <ul>
                    {datas.team_skills && datas.team_skills.map((skill) => (
                      <li
                        key={skill.skill_id}
                        className="flex items-center gap-2 my-1"
                      >
                        <span className="w-2 h-2 bg-[#006D81] rounded-full"></span>
                        <span className="text-[#828282] text-20px">
                          {skill.skill_name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="tab-content"
                  style={{ display: activeTab === "tools" ? "block" : "none" }}
                >
                  <h1> My Tools</h1>
                  <p className="text-justify text-[#828282] mb-3">
                    {datas.tool_desc}
                  </p>

                  <ul>
                    {datas.team_tools && datas.team_tools.map((tool) => (
                      <li
                        key={tool.tool_id}
                        className="flex items-center gap-2 my-1"
                      >
                        <span className="w-2 h-2 bg-[#006D81] rounded-full"></span>
                        <span className="text-[#828282] text-20px">
                          {tool.tool_name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
